<template>
  <div class="container-fluid promotion-page p-2 pt-3">
    <div class="promotion-page__inner">
      <div class="col-12 px-1 mb-5 pb-5">
        <div
          class="card bg-transparent mt-2 promotion-card"
          v-for="(promotion, proIndex) in promotions"
          :key="proIndex"
        >
          <a href="#">
            <img
              class="promotion-card__image"
              :src="promotion.image"
              :alt="promotion.title"
            >
          </a>
          <div class="px-3 py-2 d-flex justify-content-between bg-transparent">
            <h3 class="text-dark my-auto">
              {{ promotion.title }}
            </h3>
            <button
              class="detail-button col-3"
              @click="openPromotion(proIndex)"
            >
              {{ $t('detail') }}
            </button>
          </div>

          <van-overlay
            :show="selectedPromotion === proIndex"
            @click="selectedPromotion = null"
          >
            <div class="wrapper col-12 d-flex h-100vh">
              <div class="col-11 card mx-auto my-auto py-4 px-3 promotion-overlay__card">
                <h2 class="pb-3 promotion-overlay__title">
                  {{ promotion.title }}
                </h2>
                <span
                  class="promotion-overlay__description"
                  v-html="promotion.description"
                ></span>
              </div>
            </div>
          </van-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedPromotion: null,
      promotions: [
        {
          title: 'မန်ဘာသစ်ဘောနပ်စ် 200%',
          description: `
                        📌 BuffaloBossMM ၏မန်ဘာသစ်တိုင်း (𝟏) ကြိမ်သာ ရယူနိုင်ပါသည်။ <br><br>
                        📌 အနည်းဆုံးသွင်းငွေ ကျပ် 5,𝟎𝟎𝟎 အထက်ရှိရမည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ကျပ် ၃၀,၀၀၀ ဖြစ်ပါသည်။ <br><br>
                        📌 ဘောနပ်ယူပါက Free spin လုံးဝမဝယ်ရ။ <br><br>
                        📌 Turnover 𝟏𝟎  ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x 10  ] <br><br>
                        ❌❌❌ 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>
                        📌 အမြင့်ဆုံးထုတ်ယူနိုင်သည့် ပမာဏသည် 𝟏𝟎 ဆ ဖြစ်ပြီး ကျန်ယူနစ်များအား 𝐬𝐞𝐫𝐯𝐞𝐫 မှ အော်တိုနုတ်ယူသွားမည်ဖြစ်သည်။`,
          image: 'https://storage.googleapis.com/spacetech2/buffalobossmm/Promo1.avif',
        },
        {
          title: 'နေ့စဉ်ဘောနပ်စ် 20% (တစ်နေ့ 1 ကြိမ်)',
          description: `📌 BuffaloBossMM ၏မန်ဘာဟောင်းတိုင်းတစ်ရက် (𝟏) ကြိမ်ရယူနိုင်သည်။ <br><br>
                        📌 အနည်းဆုံးသွင်းငွေ ကျပ် ၃,၀၀၀ အထက်ရှိရမည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ကျပ် ၃၀,၀၀၀ ဖြစ်ပါသည်။ <br><br>
                        📌 Turnover 4  ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x ၄  ] <br><br>
                        📌 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>
                        📌 ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/buffalobossmm/Promo2.avif',
        },
        {
          title: 'ရှူံးကြေးပြန်အမ်းငွေဘောနပ်စ် 5%',
          description: `📌 တစ်ရက်အတွင်း ရှူးထားသောငွေ၏ 5% ကိုပြန်ရယူနိုင်ပါသည် ။ <br><br>
                        📌 ရှူံးကြေးကို ည 3 နာရီမှသုံးနာရီနောက်ပိုင်းတွင် system မှ auto ပြန်အမ်းပေးပါသည် ။ <br><br>
                        📌 နိုင်ငွေ 1 ဆ ပြည့်မှသာငွေထုတ်ပေးပါမည် ။ <br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည် ။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/buffalobossmm/B%20R%203.avif',
        },
        {
          title: 'သွင်းတိုင်းရ 5%',
          description: `📌 အနည်းဆုံး ၅,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် ၃၀,၀၀၀ ဖြစ်ပါသည်။ <br><br>
                        📌 နိုင်ငွေ 3ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x၃]<br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/buffalobossmm/Promo4.avif',
        },
      ],
    };
  },
  methods: {
    openPromotion(index) {
      this.selectedPromotion = index;
    },
  },
};
</script>

<style scoped>
.promotion-page {
  height: 100vh;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background:
    radial-gradient(ellipse 100% 50% at 50% 0%, rgba(215, 25, 33, 0.12) 0%, transparent 50%),
    linear-gradient(180deg, #FFE8E8 0%, #fff8f5 22%, #ffffff 55%, #f6f4f5 100%);
  background-size: cover;
  background-attachment: fixed;
  padding-bottom: 15rem;
}

.promotion-page__inner {
  height: 130vh;
}

.promotion-card {
  box-shadow: none;
}

.promotion-card__image {
  border-radius: 5px;
  width: 100%;
}

.promotion-overlay__card {
  background: #1A0A0C !important;
  border: 1px solid rgba(245, 197, 24, 0.35);
}

.promotion-overlay__title {
  color: #F5C518;
}

.promotion-overlay__description {
  color: #d4d0d0;
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 1px solid #D71921;
  text-transform: uppercase;
  border-radius: 14px;
  box-sizing: border-box;
  color: #3A080A;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 1px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background: linear-gradient(135deg, #3A080A 0%, #9B1218 50%, #D71921 100%);
  border-color: #F5C518;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
  background: linear-gradient(135deg, #3A080A 0%, #9B1218 100%);
  border-color: #3A080A;
}
</style>
